import img11a from '../../../assets/gallery/11/11a-01-HOME_ST-2011-200x300cm-oleo-sobre-papel.jpg';
import img11b from '../../../assets/gallery/11/11a-02_El-silencio-es-la-tragedia-de-mi-vida-y-no-me-importa-2011-200x300cm-oleo-sobre-papel.jpg';
import img11c from '../../../assets/gallery/11/11a-03_ST-2012-200x300cm-oleo-sobre-papel.jpg';
import img11d from '../../../assets/gallery/11/11a-04_ST-2011-75x100cm-oleo-sobre-papel.jpg';
import img11e from '../../../assets/gallery/11/11a-05-ST-2011_75x100cm-oleo-sobre-papel.jpg';

export const dataImages = [
  {
    id: '11a',
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img11a,
    description: "2011",
    orientation: "h"
  },
  {
    id: '11b',
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img11b,
    description: "2011",
    orientation: "h"
  },
  {
    id: '11c',
    title: "",
    dimensions: "200 x 300 cm",
    pictureSrc: img11c,
    description: "2011",
    orientation: "h"
  },
  {
    id: '11d',
    title: "",
    dimensions: "75 x 100 cm",
    pictureSrc: img11d,
    description: "2011",
    orientation: "h"
  },
  {
    id: '11e',
    title: "",
    dimensions: "75 x 100 cm",
    pictureSrc: img11e,
    description: "2011",
    orientation: "h"
  },
].sort(() => Math.random() - 0.5);

export const dimensionsH = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];


export const dimensionsV = [
  { width: "820" },
  { width: "730" },
  { width: "700" },
  { width: "650" },
  { width: "539" },
  { width: "444" },
  { width: "400" },
  { width: "382" },
];



// WEBPACK FOOTER //
// ./src/pages/gallery/11/data11.js